import { render, staticRenderFns } from "./teacherConfirms.vue?vue&type=template&id=ade7be5e"
import script from "./teacherConfirms.vue?vue&type=script&lang=js"
export * from "./teacherConfirms.vue?vue&type=script&lang=js"
import style0 from "./teacherConfirms.vue?vue&type=style&index=0&id=ade7be5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports